/** 소개 문장 최대 길이 — textarea 와 제안 칩 덧붙이기가 같은 상한을 본다. */
export const INTRO_MAX_LENGTH = 600;

/**
 * 제안 태그를 소개 문장 뒤에 덧붙인다. 바꿀 게 없으면 `null` 을 돌려준다
 * (이미 들어 있음 / 상한 초과) — 그때는 화면 상태를 건드리지 않는다.
 *
 * 상한을 넘으면 **자르지 않고 거절한다.** 잘린 소개가 그대로 노래가 되면 안 된다.
 */
export function appendSuggestionToIntro(intro: string, tag: string): string | null {
  const current = intro.trim();
  if (current.includes(tag)) return null;
  const next = current ? `${current}, ${tag}` : tag;
  return next.length > INTRO_MAX_LENGTH ? null : next;
}
